import React from 'react'
import PropTypes from 'prop-types'
import { find } from 'lodash'

import { colors } from '@lmc/common/constants'
import { DropdownTitle } from '../../../../../components/generic'
import MARChart from '../EMARChart/EMARChart'
import EMARLegend from './EMARLegend'
import { EmarMedicationAllDetails } from '../../../../../components/modals/AddEmarMedicationModal/components'

const renderMARChart = (props) => {
  const { endDate, medication, setEndDate, setStartDate, startDate, isPDF } =
    props

  const dateIntervalLength = endDate.diff(startDate, 'days')
  const hideScroll = dateIntervalLength < 15

  return (
    <div style={styles.chartContainer}>
      <MARChart
        displayLegend={false}
        displayMedListToggle={false}
        endDate={endDate}
        hideScroll={hideScroll}
        isPDF={isPDF}
        medications={[medication]}
        rowDisplaySettings={{
          displayFirstGutter: false,
          displayGutter: true,
          displayMedName: false,
        }}
        setEndDate={setEndDate}
        setStartDate={setStartDate}
        startDate={startDate}
      />
    </div>
  )
}

const renderLegend = () => {
  return (
    <div style={styles.legendContainer}>
      <EMARLegend />
    </div>
  )
}

const renderMedicationDetailsList = (props) => {
  const { emarRoundTimings, medication } = props

  const medicationDetails = {
    ...medication,
    emarRoundsDetails: medication.emarRoundsDetails.map((round) => {
      return {
        ...round,
        time: find(emarRoundTimings, { id: round.emarRoundTiming }).time,
      }
    }),
  }
  return (
    <div style={styles.medDetailsListContainer}>
      <div style={styles.detailsContainer}>
        <EmarMedicationAllDetails
          displayTitle={false}
          fields={medicationDetails}
          formState={{ isFixedDose: false }}
        />
      </div>
    </div>
  )
}

/**
@description Renders medication screen details section.

@param {object} endDate. The chart end date. A dayjs object.

@param {array} emarRoundTimings. The different rounds for that home e.g. 14:00, 19:00 etc.
Not all medications are administered at every round.

@param {array} logs. The logs for the medication

@param {object} medication. The medication.

@param {function} openDiscontinueMedModal. Opens the DiscontinueMed modal.

@param {object} resident. The resident.

@param {function} setEndDate. Sets the chart end date.

@param {function} setStartDate. Sets the chart start date.

@param {function} setViewMedDetails. Sets whether the medication
details are visible.

@param {object} startDate. The chart start date. A dayjs object.

@returns {function} ResidentEMARMedicationScreen
*/
export default function EMARMedicationScreenDetailsSection(props) {
  const {
    endDate,
    medication,
    setEndDate,
    setStartDate,
    setViewMedDetails,
    startDate,
    viewMedDetails,
    isPDF,
  } = props

  return (
    <div style={styles.medDetailsSectionContainer}>
      <DropdownTitle
        isOpen={medication.deleted ? !viewMedDetails : viewMedDetails} // This is incredibly hacky...
        title={'Medication Details'}
        toggleOpen={() => {
          setViewMedDetails(!viewMedDetails)
        }}
      >
        {renderMARChart({
          ...props,
          startDate,
          endDate,
          setStartDate,
          setEndDate,
        })}
        {renderLegend()}
        {isPDF && renderMedicationDetailsList(props)}
      </DropdownTitle>
    </div>
  )
}

EMARMedicationScreenDetailsSection.propTypes = {
  emarRoundTimings: PropTypes.array.isRequired,
  endDate: PropTypes.object.isRequired,
  medication: PropTypes.object.isRequired,
  resident: PropTypes.object.isRequired,
  setEndDate: PropTypes.func.isRequired,
  setStartDate: PropTypes.func.isRequired,
  setViewMedDetails: PropTypes.func.isRequired,
  startDate: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  viewMedDetails: PropTypes.bool.isRequired,
}

const styles = {
  buttonsContainer: {
    marginLeft: 16,
  },
  chartContainer: {
    marginTop: 8,
  },
  detailsContainer: {
    width: '100%',
  },
  discontinueBtn: {
    color: colors.white,
  },
  // discontinueBtnContainer: {
  //     marginTop: 16
  // },
  legendContainer: {
    marginTop: 8,
  },
  medDetailsListContainer: {
    display: 'flex',
    marginTop: 16,
  },
  medDetailsSectionContainer: {
    marginBottom: 36,
  },
}
